import { Permission } from '@/lib/permissions/v1'

export enum CompanySendRoute {
    SendEmail = 'company.send.email',
}

export default {
    path: 'send/email',
    name: CompanySendRoute.SendEmail,
    component: () => import('@/views/company/send/email/Index.vue'),
    meta: {
        label: 'Send Email',
        auth: true,
        permission: Permission.CompanyUpdate,
    },
    children: [],
}
